var map = {
	"./Seaglass-logo-RGB.jpg": 1493,
	"./Seaglass-logo-large.png": 1494,
	"./Seaglass-logo-small.png": 449,
	"./Seaglass-logo-transparent.png": 687,
	"./average-connection-16.png": 1495,
	"./good-connection-16.png": 1496,
	"./logo blue.jpg": 1497,
	"./logo.jpg": 1498,
	"./no-connection-16.png": 1499,
	"./poor-connection-16.png": 1500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;